import {AfterViewInit, Component, Directive, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';
import {BsModalRef, BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {ToastrService} from 'ngx-toastr';
import {ConfirmDialogComponent} from '../../../dialog/confirmdialog.component';
import {language} from '../../../../language/vn';
import {CommandUtil} from '../../../../global/commandutil';
import {Subject} from 'rxjs';
import {DatePipe} from '@angular/common';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {NavItemService} from '../../../../service/staff/service-navitem';
import {FormatService} from '../../../../service/format/service-format';
import {VanBanDiService} from '../../../../service/vanbandi/service-vanbandi';
@Component({
  templateUrl: './thoihan.component.html',

})
export class ThoiHanVanBanDiComponent implements OnInit, AfterViewInit {

  public id: number = -1;
  public language = language;
  public showAction = true;
  public  onClose: Subject<boolean>;
  public submitValidate = false;
  public dateThoiHan: Date;
  public permissionGXL: boolean = false;
  constructor(
    public toastr: ToastrService,
    public formBuilder: FormBuilder,
    public bsModalService: BsModalService,
    public _bsModalRef: BsModalRef,
    public commandUtil: CommandUtil,
    public vanBanDiService: VanBanDiService,
    public navItemService: NavItemService,
    public datePipe: DatePipe,
    public commandUtils: CommandUtil,
    public formatService: FormatService
  ) {
  }
  ngAfterViewInit() {

  }

  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }

  ngOnInit(): void {
    this.onClose = new Subject();
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId, '0032', true).subscribe(
      x => {
        this.permissionGXL = x >0? true: false;
      }
    );
  }
  public edit(id: number) {
    this.id = id;
    this.vanBanDiService.getById(id).subscribe(x => {
      this.dateThoiHan = this.commandUtils.getDate(x.thoiHan);
    });

  }

  public actionThoiHan ()
  {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_save_thoihan_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.formatService.getCompareDate(this.datePipe.transform(this.dateThoiHan, 'MM/dd/yyyy')).subscribe(
          y => {
            if (y > 0) {
              let thoiHan: string = this.datePipe.transform(this.dateThoiHan, 'dd/MM/yyyy');
              this.vanBanDiService.changeThoiHan(this.id, thoiHan).subscribe(
                {    next: (data) => {
                    this.toastr.success(language.message_thoihan_success, language.message);
                    Sessioncommand.vanBanDiStatus = 0;
                    Sessioncommand.notification = true;
                    this.onSave();
                  },
                  error: error => {
                    this.toastr.error(language.error, language.message);
                  }
                });
            } else {
              this.toastr.error(language.message_thoihan_error, language.message);
            }
          });
      }
    });
  }

  public onSave(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }
}

